import { MutationTree } from "vuex";
import { MapLayersState, MapItemData, MapLayerData } from "./types";
import Vue from "vue";
import { getDefaultState } from "./state";
import { CancelTokenSource } from "axios";

export const mutations: MutationTree<MapLayersState> = {
	setMapLayers(state, data) {
		if (state.ZoomLevel !== "wide") {
			data.layers.forEach(addLayer => {
				addLayer.upLevel = addLayer.minElevation! > state.Elevation;
				addLayer.downLevel = addLayer.maxElevation! < state.Elevation;

				addLayer.currentLevel = !(addLayer.upLevel || addLayer.downLevel);
			});
		}

		state.MapLayer = data;
	},
	setMapLayersForGroup(state, data) {
		state.MapLayersForGroup = data;
	},
	mapLayersBounds(state, data) {
		state.MapLayersBounds = data;
	},
	setManualRaiseMarkerPosition(state, position) {
		state.ManualRaiseMarkerPosition = position;
	},
	setManualRaiseLayers(state, layers: any[]) {
		state.ManualRaiseLayers = layers;
	},
	setSelectedManualRaiseLayer(state, layer: any) {
		state.ManualRaiseSelectedLayer = layer;
	},
	setLayerHidden(state, { mapLayerID, hidden }) {
		if (hidden) state.LayersHidden.add(mapLayerID);
		else state.LayersHidden.delete(mapLayerID);
	},
	setElevation(state, elevation: number) {
		state.Elevation = elevation;

		if (state.ZoomLevel !== "wide" && state.MapLayer && state.MapLayer.layers) {
			state.MapLayer.layers.forEach(addLayer => {
				addLayer.upLevel = addLayer.minElevation! > state.Elevation;
				addLayer.downLevel = addLayer.maxElevation! < state.Elevation;

				addLayer.currentLevel = !(addLayer.upLevel || addLayer.downLevel);
			});
		}
	},
	setZoomLevel(state, zoomLevel) {
		if (zoomLevel !== state.ZoomLevel) {
			state.ZoomLevel = zoomLevel;
			if (state.ZoomLevel !== "wide" && state.MapLayer && state.MapLayer.layers) {
				state.MapLayer.layers.forEach(addLayer => {
					addLayer.upLevel = addLayer.minElevation! > state.Elevation;
					addLayer.downLevel = addLayer.maxElevation! < state.Elevation;

					addLayer.currentLevel = !(addLayer.upLevel || addLayer.downLevel);
				});
			}
		}
	},
	setSelectedMapElevation(state, elevation: number) {
		state.MapSelectedElevation = elevation;
	},
	setMapLayersItemTypes(state, data) {
		state.MapLayersItemTypes = data;
	},
	setMapLayersItemType(state, { id, data }) {
		let idx = state.MapLayersItemTypes.findIndex(m => m.mapLayerItemTypeID === id);
		if (idx !== -1) {
			Vue.set(state.MapLayersItemTypes, idx, data);
		}
		else {
			state.MapLayersItemTypes = state.MapLayersItemTypes.concat(data);
		}
	},
	setCancelTokenSource(state, cancelTokenSource: CancelTokenSource) {
		state.cancelTokenSource = cancelTokenSource;
	},
	clearMapLayers(state) {
		state.MapLayer = {
			elevations: []
		};
	},
	resetState(state) {
		Object.assign(state, getDefaultState());
	},

	addMapLayer(state, mapLayer: MapLayerData) {
		if (state.MapLayer.layers.findIndex((x: MapLayerData) => x.mapLayerID == mapLayer.mapLayerID) == -1) {
			state.MapLayer.layers.push(mapLayer);
		}
	},

	removeMapLayer(state, mapLayerId: number) {
		const index = state.MapLayer.layers.findIndex((item: MapLayerData) => item.mapLayerID === mapLayerId);

		state.MapLayer.layers.splice(index, 1);
	},

	removeMapLayerItem(state, mapLayerItemId: number) {
		const index = state.MapLayer.items.findIndex((item: MapItemData) => item.mapLayerItemID === mapLayerItemId);

		state.MapLayer.items.splice(index, 1);
	}
};
